import type { AuthError, Session } from "@supabase/supabase-js";
import { createContext } from "react";
import type { Database } from "../types/database";
import type { AccessDecision } from "./access";
import type { AppEnv } from "../config/env";
import type { RuntimeContainer } from "../runtime/container/container";
import type { HealthCheckResult } from "../services/health";

type Profile = Database["public"]["Tables"]["profiles"]["Row"];
type Role = Pick<Database["public"]["Tables"]["roles"]["Row"], "code" | "name">;

export type AuthStatus =
  | "unknown"
  | "checking"
  | "authorized"
  | "denied"
  | "error"
  | "signed_out"
  | "oauth_redirecting";

export type AuthContextValue = {
  access: AccessDecision;
  error: string | null;
  profile: Profile | null;
  roles: Role[];
  session: Session | null;
  signInWithGoogle: () => Promise<{ error: AuthError | null }>;
  signOut: () => Promise<void>;
  resetAuthAttempt: () => void;
  status: AuthStatus;
  appEnv: AppEnv | null;
  runtimeContainer: RuntimeContainer | null;
  healthChecks: HealthCheckResult[];
  isHealthRefreshing: boolean;
  refreshHealth: () => Promise<void>;
  refreshRuntime: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextValue | null>(null);
